export const USER_REQUEST = "USER_REQUEST";
export const USER_REQUEST_PROMISE = "USER_REQUEST_PROMISE";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_ERROR = "USER_ERROR";